module.exports = __webpack_public_path__ + "static/media/chevron-right-circle.2c301d66.svg";